/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { CircularProgress, Accordion, AccordionDetails, List, ListItemText, Paper, Grid } from '@mui/material';
import { ListItemButton } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendRequestAndReceiveResponse, toUrlLookupBody } from '../common/common';
import { getServiceBulletinsURLEndPoint, getServiceTicketEndpoint, markNotificationReadEndpoint, trackemailvisitEndpoint, emailnotificationtype } from '../common/constants';
import { checkLocalStorageExpiry, loadFromLocalStorage } from '../common/localStorage';
import bulletinIcon from '../images/Service_Bulletin_Pin_Grey.png';
import { AuthService } from '../services/AuthServices';
import { actionCreators } from '../store/Notification';
import MenuList from './MenuList';
import { withRouterCompat } from '../common/withRouter';
import classNames from 'classnames';

interface Props {
    theme: Theme;
    classes?: any;
    children?: any;
    getNotifications: Function;
    isLoading: boolean;
    data: any;
    error: any;
    totalCount: any;
    isMenuExpanded: boolean
}
interface State {
    contentRight: any;
    currentUrl: any;
    currentNotificationId: any;
    currentNotificationViewed: any;
    contentHeader: string;
    selectedfilter1Value: any
    selectedfilter2Value: any
    displayAll: boolean;
    isRunningFromDesktop: boolean;
    isAuthenticatedOnce: boolean;
    isexpanded: boolean;
    selected: any;
    currentDate: any;
}
const styles = (theme: Theme) => ({
    notificationLeft: {
        width: '28vw'
    },
    notificationLeftExpanded: {
        width: '25vw'
    },
    leftHeight: {
        height: '87vh',
    },
    container: {
        width: '100%',
        height: '87vh',
        justifyContent: 'space-evenly'
    },
    listItem: {
        height: '87vh',
        padding: '15px'
    },
    right: {
        width: '70%'
    },
    progressWrap: {
        textAlign: 'center' as 'center',
        marginTop: '20vh'
    },
    progress: {
        margin: ((theme as any) && typeof (theme as any).spacing === 'function') ? (theme as any).spacing(2) : '16px'
    },
    bold: {
        fontWeight: 600,
    },
    normal: {
        fontWeight: 400,
    },
    filter: {
        paddingLeft: '10px',
        paddingRight: '15px',
        justifyContent: 'space-between',
        paddingTop: '20px'
    },
    text: {
        justifyContent: 'center',
        marginTop: '7px'
    },
    font10: {
        fontSize: '10px'
    },
    font11: {
        fontSize: '11px'
    },
    font13: {
        fontSize: '13px'
    },
    font17: {
        fontSize: '17px'
    },
    leftPanelistItem: {

        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        width: '80%',
        paddingLeft: '25px'
    },
    date: {
        marginBottom: '0px',
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        width: '100%'
    },
    listItemRoot: {
        borderRadius: '4px',
        border: '1px solid #d6d6d6',
        marginBottom: '2px',
        '&:focus': {
            borderBottom: '2px solid #ffbe00',
        }
    },
    selectedListItem: {
        borderRadius: '4px',
        border: '1px solid #d6d6d6',
        marginBottom: '2px',
        borderBottom: '2px solid #ffbe00'
    },
    rootList: {
        padding: '12px',
        overflowY: 'scroll',
        maxHeight: '86%'
    },
    listItemText: {
        marginRight: '-25px',
        paddingRight: '0'
    },
    headerLeft: {
        maxWidth: '70%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    contentRightHeader: {
        justifyContent: 'space-between'
    },
    rightPaper: {
        overflowY: 'scroll'
    },
    limitedTag: {
        backgroundColor: '#ffbe00',
        color: '#000',
        padding: '2px 6px',
        borderRadius: '4px',
        marginLeft: '10px',
        fontSize: '10px',
        fontWeight: 'bold',
        display: 'inline-block',
        marginRight: '10px'
    }
});

class Notification extends React.Component<Props, State>{
    filter1 = [{ id: 1, name: 'All', displayAll: true }, { id: 2, name: 'Unread', displayAll: false }];
    filter2 = [{ id: 1, name: 'Bulletin' }];
    state = {
        contentRight: '',
        currentUrl: '',
        currentNotificationId: 0,
        currentNotificationViewed: false,
        contentHeader: '',
        selectedfilter1Value: 'All',
        selectedfilter2Value: 'Bulletin',
        displayAll: true,
        isRunningFromDesktop: false,
        isAuthenticatedOnce: false,
        isexpanded: false,
        selected: 0,
        currentDate: ''
    };

    handleViewingClick = (item: any) => {
        const value = this.filter1.find((x: any) => {
            return x.id === item;
        });
        if (value !== undefined) {
            this.setState({
                selectedfilter1Value: value.name,
                displayAll: value.displayAll,
                selected: undefined,
                contentRight: '',
                currentUrl: '',
                isexpanded: false,
                currentDate: '',
                contentHeader: ''
            });
        }
    };
    refresh() {
        checkLocalStorageExpiry();
        const authToken = loadFromLocalStorage('AuthToken');
        if (authToken === null || authToken === undefined) {
            new AuthService().login();
        }
    }
    componentDidMount() {
        this.refresh();
        const searchParams = new URLSearchParams(window.location.search);
        const origin = searchParams.get("origin");
        if (window.location.pathname.includes("notification") && origin === "Email") {
            void this.trackVisit();
        }
        const clientMode: any = loadFromLocalStorage('Client Mode');
        if (clientMode != null && clientMode !== undefined && clientMode === 'Desktop') {
            this.setState({ isRunningFromDesktop: true });
        }
        this.props.getNotifications();
    }

    trackVisit = () => {
        try {
            const token: string = loadFromLocalStorage('AuthToken');
            const encodedToken = 'Bearer ' + token;
            const headerDict: any = {
                'Authorization': encodedToken,
                'Content-Type': 'application/json'
            };
            const requestBody = { 'SubscriptionType': emailnotificationtype };
            const response: any = fetch(trackemailvisitEndpoint, {
                headers: new Headers(headerDict),
                body: JSON.stringify(requestBody),
                method: 'POST'
            });
            if (!response.ok) {
                console.error("Failed to track visit:", response.statusText);
            }
        } catch (error) {
            console.error("Error tracking visit:", error);
        }
    };

    componentDidUpdate(_prevProps: any, prevState: any, _snapshot: any) {
        if (prevState !== this.state) {
            this.refresh();
        }
    }
    renderNotificationLeft = (title: string, _shortMessage: string, id: any, createdDate: any, isViewed: boolean, classes: any, shouldDisplay: boolean,isLimited:boolean) => {
        return (
            !shouldDisplay &&
            <ListItemButton key={id} onClick={this.displayContentRight(id)} className={this.state.selected === id ? classes.selectedListItem : classes.listItemRoot}>
                <ListItemText className={classes.listItemText}>
                    <Grid container>
                        <span><img src={bulletinIcon} width="40px" height="40px" /></span>
                        <div className={isViewed ? classNames(classes.normal, classes.leftPanelistItem) : classNames(classes.bold, classes.leftPanelistItem)}>
                            <Grid container className={classes.date}>
                                    <Grid className={classNames(classes.font13, classes.headerLeft)}>{id}</Grid>
                                    {isLimited && <Grid className={classes.limitedTag}>Limited</Grid>}
                                <Grid className={classes.font11}>{
                                    new Date().toLocaleDateString() === new Date(createdDate + 'Z').toLocaleDateString() ?
                                        new Date(createdDate + 'Z').toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) :
                                        new Date(createdDate + 'Z').toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
                                </Grid>
                            </Grid>
                            <span className={classes.font11}>{title}
                            </span>
                        </div>
                    </Grid>
                </ListItemText>
            </ListItemButton>
        );
    };
    displayContentRight = (id: any) => (_event: React.MouseEvent<HTMLElement>) => {
        const bn = this.props.data[0].bulletinNotification.find((x: any) => x.serviceBulletinNumber === id);
        this.setState({
            contentHeader: bn.serviceBulletinNumber,
            contentRight: bn.description,
            currentUrl: bn.url,
            currentNotificationId: bn.notificationId, currentNotificationViewed: bn.isViewed,
            isexpanded: false,
            selected: id,
            currentDate: bn.createdDate
        }, () => {
            const iframeobject: any = document.getElementById('myIframe');
            if (iframeobject != null) {
                iframeobject.src = '';
            }
            this.MarkNotificationRead(this.state.currentNotificationViewed, this.state.currentNotificationId);
        });
    };
    render() {
        const { classes, isLoading, isMenuExpanded } = this.props;
        return (
            !isLoading ?
                (<Grid container className={classes.container}>
                    <Grid className={isMenuExpanded ? classes.notificationLeftExpanded : classes.notificationLeft}>
                        <Paper className={classes.leftHeight}>
                            <Grid id="filterSection" className={classes.filter} container>
                                <Grid>
                                    <MenuList listItems={this.filter1} onClick={this.handleViewingClick} selectTitle={'Viewing'}
                                        displaySelectedItemInTitle={true} selectedItem={this.state.selectedfilter1Value} />
                                </Grid>
                                <Grid>
                                    <MenuList listItems={this.filter2} onClick={this.handleViewingClick} selectTitle={'Type'}
                                        displaySelectedItemInTitle={true} selectedItem={this.state.selectedfilter2Value} />
                                </Grid>
                            </Grid>
                            <Grid container className={classNames(classes.text, classes.font11)}>From Last 60 Days</Grid>
                            <List component="nav" className={classes.rootList}>
                                {this.props.data !== undefined && this.props.data.length === 1 && this.props.data[0].bulletinNotification !== undefined &&
                                    this.props.data[0].bulletinNotification.map((x: any) => {
                                        return this.renderNotificationLeft(x.title, x.message, x.serviceBulletinNumber, x.createdDate, x.isViewed,
                                            classes, (this.state.displayAll === false && x.isViewed === true),x.isLimited);
                                    }
                                    )}
                            </List>
                        </Paper>
                    </Grid>
                    <Grid className={classes.right}>
                        <Paper className={classes.rightPaper}>
                            <div className={classes.listItem}>
                                <Grid container className={classes.contentRightHeader}>
                                    <Grid>
                                        <p className={classNames(classes.font17, classes.bold)}>{this.state.contentHeader}</p>
                                    </Grid>
                                    <Grid className={classes.font13}>

                                        {this.state.currentDate !== '' && `${new Date(this.state.currentDate + 'Z')
                                            .toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
                                            } ${new Date(this.state.currentDate + 'Z').toLocaleTimeString()}`
                                        }

                                    </Grid>
                                </Grid>
                                <div className={classNames(classes.font13, classes.normal)}>
                                    <p>{this.state.contentRight}</p>
                                    {this.state.currentUrl !== '' ?
                                        (
                                            <Accordion expanded={true}>
                                                <AccordionDetails style={{ height: '70vh', padding: '0px' }}>
                                                    {this.state.isAuthenticatedOnce &&
                                                        <iframe width="100%" height="100%" src={''} scrolling="yes" name="myIframe" id="myIframe"> </iframe>}
                                                </AccordionDetails>
                                            </Accordion>


                                        ) : <div />
                                    }
                                </div>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>)
                : <div className={classes.progressWrap}>
                    <CircularProgress className={classes.progress} color="secondary" />
                </div>
        );
    }

    MarkNotificationRead = async (currentNotificationViewed: boolean, currentNotificationId: number) => {
        this.setState({ isexpanded: !this.state.isexpanded });
        let url = '';
        if (this.state.currentUrl.includes('docushare')) {
            const requestBody = {
                TicketGrantingTicketUrl: window.atob(loadFromLocalStorage('TGT')),
                ServiceName: 'http://trl.trimble.com/docushare/sso_login?location=' + this.state.currentUrl
            };
            const token: string = loadFromLocalStorage('AuthToken');
            const encodedToken = 'Bearer ' + token;
            const headerDict: any = {
                'Authorization': encodedToken,
                'Content-Type': 'application/json'
            };
            const response: any = await fetch(getServiceTicketEndpoint, {
                headers: new Headers(headerDict),
                body: JSON.stringify(requestBody),
                method: 'POST'
            });
            const responseData = await response.json();
            if (response.body !== undefined) {
                url = `${import.meta.env.VITE_BULLETIN_URL + this.state.currentUrl}&ticket=${responseData.serviceTicket}`;
            }

        }
        else {
            const BulletinUrl = await sendRequestAndReceiveResponse(
                toUrlLookupBody(this.state.currentUrl)
                , getServiceBulletinsURLEndPoint);
            url = BulletinUrl.presignedURL;
            console.log(BulletinUrl.presignedURL);
        }

        if (url !== '') {
            const iframeobject: any = document.getElementById('myIframe');
            if (iframeobject != null) {
                iframeobject.src = url;
            }
            if (!this.state.isAuthenticatedOnce) {
                this.setState({ isAuthenticatedOnce: true }, () => {
                    const iframeobject: any = document.getElementById('myIframe');
                    if (iframeobject != null) {
                        iframeobject.src = url;
                    }
                });
            }
        }
        this.MarkNotificationReadFunction(currentNotificationViewed, currentNotificationId);
    };

    MarkNotificationReadFunction = async (currentNotificationViewed: boolean, currentNotificationId: number) => {
        if (!currentNotificationViewed) {
            const token: string = loadFromLocalStorage('AuthToken');
            const encodedToken = 'Bearer ' + token;
            const headerDict: any = {
                'Authorization': encodedToken,
                'Content-Type': 'application/json'
            };
            const requestBody =
            {
                notificationId: currentNotificationId
            };

            try {
                if (navigator.onLine) {
                    const response = await fetch(markNotificationReadEndpoint, {
                        headers: new Headers(headerDict),
                        body: JSON.stringify(requestBody),
                        method: 'POST'
                    });
                    if (response.status === 200) {
                        this.props.getNotifications(false);
                    }
                    return response;
                }
            }
            catch (e) {
                console.log(e);
            }
        }
    };
}

const mapStateToProps = (state: any) => ({
    state: state.notification,
    isLoading: state.notification.isLoading,
    data: state.notification.data,
    totalCount: state.notification.totalCount,
    error: state.notification.error,
    isMenuExpanded: state.navMenu.isMenuExpanded
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(withRouterCompat(withStyles(styles as any, { withTheme: true })(Notification as any)) as any);
